import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {UnitsService} from '@catmodules/models/units/services/units.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';
import {FeatureGgwFixedRoutesService} from "@catmodels/ggw-fixed-routes/services/feature-ggw-fixed-routes.service";
import {extractDataFromProperty, sortByLabelFunc} from "@catcore/utils";

/**
 * A component to fast create a new FeatureUnit for the currently in use Feature
 *
 * A new FeatureUnit inherits the some properties of its linked Unit.
 *
 * This properties are:
 * - updateGroup
 */
@Component({
  templateUrl: './feature-fixed-routes-landing.component.html',
})
export class FeatureFixedRoutesLandingComponent extends BaseFeatureWelcomeComponent {

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfTitle = 'Fixed Route';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfTitle}`;

  /**
   * All potential linkable Ggw Device items
   */
  ggwDevices: SelectItem[];

  /**
   * Label names to be used by form input elements.
   */
  labels = {
    source: 'Source',
    output: 'Output',
    sink: 'Sink',
    input: 'Input',
    buttons: {
      last: `Save the ${this.selfTitle}`,
    },
  };

  outputOptions = [];

  private staticInputOptions = [
    {value: null, label: 'Auto-resolve by CAT'}
  ];

  inputOptions = [
    ...this.staticInputOptions
  ];

  /**
   * Returns true if the current form object is ready.
   * Ready means all necessary data that is required to display and use the form, is available
   * @returns {boolean}
   */
  get formIsReady() {
    let isReady = !isNullOrUndefined(this.getFeature());
    isReady = isReady && !isNullOrUndefined(this.ggwDevices);
    return isReady;
  }

  resetAfterComplete = true;

  private inputsPerSink = [];

  constructor(private route: ActivatedRoute,
              featureService: FeatureTypeService,
              private featureGgwFixedRoutesService: FeatureGgwFixedRoutesService) {
    super(featureService);

    this.form = new FormGroup({
      source: new FormControl('', [Validators.required]),
      output: new FormControl('', [Validators.required]),
      sink: new FormControl('', [Validators.required]),
      input: new FormControl('', []),
    });

  }

  /**
   * Executes the request to create a new FeatureUnit
   *
   */
  /**
   * Creates a new entity
   *
   * The 'isVirtual' property needs to check explictly because it can still be NULL if the form was reset on one point
   */
  saveNewEntity() {

    this.featureGgwFixedRoutesService
      .create(this.form.value)
      .subscribe((featureGgwFixedRoute) => {
        this.setCurrentEntity(featureGgwFixedRoute);
        this.setIsCompleted(featureGgwFixedRoute !== null);
        this.getFeatureService().refreshCurrent();
      });
  }

  /**
   * Updates the current usable GgwDevices items as soon as a new item list is available
   */
  beforeDisplayProperties(): void {
    this
      .getFeatureService()
      .getGgwDevices(this.feature.id)
      .subscribe((ggwDevices: any[]) => {
        this.updateGgwDevicesSelectItems(ggwDevices);
      });
  }

  validatePropertiesView() {
  }

  sourceSelected($event) {
    const source = $event.value;
    this.outputOptions = [];
    if (source) {
      source._embedded.model.outputs.forEach((output) => {
        this.outputOptions.push({value: output, label: output});
      });
      this.outputOptions.sort(sortByLabelFunc);
    }
  }

  sinkSelected($event) {
    const sink = $event.value;
    let inputOptions = [];
    if (sink) {
      sink._embedded.model.inputs.forEach((input) => {
        inputOptions.push({value: input, label: input});
      });
      // make array unique
      inputOptions = this.featureGgwFixedRoutesService.concatArraysUnique(inputOptions, this.inputsPerSink[sink.name]);
      inputOptions.sort(sortByLabelFunc);
    }
    this.inputOptions = [
      ...this.staticInputOptions,
      ...inputOptions
    ];
  }

  private updateGgwDevicesSelectItems(ggwDevices) {
    this.ggwDevices = [];
    ggwDevices
      .filter((item) => {
        return item._embedded.model.inputs.length > 0
          || item._embedded.model.outputs.length > 0;
      })
      .forEach((item) => {
        const itemLabel = item.name;
        this.inputsPerSink[itemLabel] = this.featureGgwFixedRoutesService.extractInputOptions(item);
        this.ggwDevices.push({label: itemLabel, value: item});
    });

    this.ggwDevices.sort(sortByLabelFunc);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-fixed-routes-landing/feature-fixed-routes-landing.component.ts